module.exports = __webpack_public_path__ + "static/media/sell-used-vans-toowoomba.7bf80c3b.png";